module.exports = "/static/assets/55b5fb66d32f05f6fbcb0995a71e64c2.png";